import { useContext } from "react";
import { useSelector } from "react-redux";

import { getAwardText } from "../../../selectors";
import { BaseBenefitsList } from "../../BaseComponents/BaseBenefitsList";
import { BaseColumnInformation } from "../../BaseComponents/BaseColumnInformation";
import { BaseCompanyLogo } from "../../BaseComponents/BaseCompanyLogo";
import BaseCompanyName from "../../BaseComponents/BaseCompanyName";
import BaseCouponDescription from "../../BaseComponents/BaseCouponDescription";
import BaseGridRatingHorizontal from "../../BaseComponents/BaseGridRatingHorizontal";
import BaseLinkWrapper from "../../BaseComponents/BaseLinkWrapper";
import BaseReviewLink from "../../BaseComponents/BaseReviewLink";
import BaseServiceFlag from "../../BaseComponents/BaseServiceFlag";
import { BaseTrustpilotReview } from "../../BaseComponents/BaseTrustpilotReview";
import { BaseVisitLink } from "../../BaseComponents/BaseVisitLink";
import { CompanyContext } from "../../CompanyList/CompanyContext";
import { PhoneLink } from "./PhoneLink";
import { getStyles } from "./styles";
import {
	DEFAULT_LINK_TEXT,
	ThemeContext,
	TRUSTPILOT_REVIEW_WIDGET,
	WEB_REVIEW_WIDGET,
} from "./ThemeContext";

export const FavyColumns = () => {
	const { company } = useContext(CompanyContext);
	const {
		linkText = DEFAULT_LINK_TEXT,
		hasReviewWidget = false,
		rendersCoupon = false,
		rendersPhoneLink = false,
	} = useContext(ThemeContext);
	const awardText = useSelector((state) => getAwardText(state, { company }));
	const styles = getStyles({ awardText });

	return (
		<div className={`tw-relative [border-top:1px_solid_#e5e7eb]`}>
			<div className="tw-bg-white">
				<div className="tw-relative tw-mx-auto tw-mt-4 tw-flex tw-max-w-[500px] tw-flex-col desktop:tw-max-w-none desktop:tw-flex-row">
					<BaseServiceFlag classNames={styles.serviceFlag} />

					<div
						className={`tw-flex tw-w-full tw-px-4 tw-pt-4 desktop:tw-w-[240px] desktop:tw-items-center desktop:tw-justify-center desktop:tw-px-0 desktop:tw-pt-0 lg:tw-w-[260px] lg2:tw-w-[284px]`}
					>
						<BaseLinkWrapper
							className={`tw-flex tw-w-full tw-flex-col tw-items-center`}
						>
							<BaseCompanyLogo classNames={styles.companyLogo} />

							{hasReviewWidget === TRUSTPILOT_REVIEW_WIDGET && (
								<BaseTrustpilotReview classNames={styles.trustpilotReview} />
							)}
							{hasReviewWidget === WEB_REVIEW_WIDGET && (
								<BaseGridRatingHorizontal classNames={styles.rating} />
							)}
						</BaseLinkWrapper>
					</div>

					<div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-4 desktop:tw-flex-row desktop:tw-px-0">
						<div className="tw-flex tw-w-full tw-max-w-[340px] tw-flex-col desktop:tw-max-w-none desktop:tw-flex-row">
							<BaseLinkWrapper>
								<BaseCompanyName className="tw-mb-4 tw-text-xl tw-font-bold tw-leading-6 tw-text-gray-900" />
								<BaseBenefitsList
									{...styles.benefitsList}
									isExpandable={true}
									mobileItemsToShow={2}
								/>
							</BaseLinkWrapper>

							<BaseLinkWrapper className="tw-mt-4 tw-flex tw-w-full tw-items-center desktop:tw-mt-0 desktop:tw-w-[240px] lg2:tw-w-[286px]">
								<BaseColumnInformation classNames={styles.columnInformation} />
							</BaseLinkWrapper>
						</div>
					</div>
					<div className="tw-mb-5 tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-px-8 desktop:tw-mb-0 desktop:tw-flex-1 desktop:tw-px-2 lg:tw-px-3 lg2:tw-px-4">
						{rendersPhoneLink && (
							<PhoneLink className="tw-relative tw-inline-flex tw-h-[40px] tw-w-[190px] tw-items-center tw-justify-center tw-rounded-full tw-bg-[#38a169] tw-text-sm tw-font-bold tw-text-white hover:tw-bg-[#2f855a] desktop:tw-w-full desktop:tw-max-w-[190px]" />
						)}

						<BaseLinkWrapper className="tw-relative tw-inline-flex tw-h-[40px] tw-w-[190px] tw-items-center tw-justify-evenly tw-rounded-full tw-bg-[#38a169] tw-text-sm tw-font-bold tw-text-white hover:tw-bg-[#2f855a] desktop:tw-w-full desktop:tw-max-w-[190px]">
							<BaseVisitLink>{linkText}</BaseVisitLink>
						</BaseLinkWrapper>

						{rendersCoupon && (
							<BaseLinkWrapper>
								<BaseCouponDescription classNames={styles.couponDescription} />
							</BaseLinkWrapper>
						)}

						<BaseReviewLink
							classNames={styles.reviewLink}
							linkText="Read Review"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
